var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaPflegehilfsmittel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#336686;}.cls-3{fill:#38aaff;}.cls-4{fill:#4c78a0;}.cls-5{fill:#628fb1;}.cls-6{fill:#d9efec;}.cls-7{fill:#f55;}.cls-8{fill:#f72b2b;}.cls-9{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 13.06,
    width: 144,
    height: 133.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.58,68.89a2.14,2.14,0,0,1-2.14-2.14V42.46a23.62,23.62,0,0,0-37.59-19A2.14,2.14,0,1,1,92.31,20a27.91,27.91,0,0,1,44.41,22.5V66.75a2.14,2.14,0,0,1-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.58,81.67h-12V70.28a3.53,3.53,0,0,1,3.53-3.53H137a3.53,3.53,0,0,1,3.54,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.7,102.94c0-14.7-7.66-26.61-17.12-26.61s-17.13,11.91-17.13,26.61,7.67,26.62,17.13,26.62,17.12-11.92,17.12-26.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.7,102.94c0,14.7-7.66,26.62-17.12,26.62a11.49,11.49,0,0,1-3.86-.68c7.61-2.72,13.28-13.3,13.28-25.94S138.33,79.72,130.72,77a11.48,11.48,0,0,1,3.86-.67c9.46,0,17.12,11.91,17.12,26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.16,144.77H52.6A7.79,7.79,0,0,1,44.81,137V47.26a7.79,7.79,0,0,1,7.79-7.79H98.16a7.78,7.78,0,0,1,7.78,7.79V137a7.78,7.78,0,0,1-7.78,7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.94,47.26V137a7.78,7.78,0,0,1-7.78,7.79h-9A7.79,7.79,0,0,0,97,137V47.26a7.79,7.79,0,0,0-7.79-7.79h9a7.78,7.78,0,0,1,7.78,7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.94,47.26v4A7.78,7.78,0,0,1,98.16,59H52.6a7.78,7.78,0,0,1-7.78-7.63.76.76,0,0,1,0-.15v-4a.76.76,0,0,1,0-.15,7.78,7.78,0,0,1,7.78-7.64H98.16a7.78,7.78,0,0,1,7.78,7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.94,47.26v4A7.78,7.78,0,0,1,98.16,59H97V47.26a7.79,7.79,0,0,0-7.79-7.79h9a7.78,7.78,0,0,1,7.78,7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95,49.25a2.14,2.14,0,0,1-2.14,2.14h-48a.76.76,0,0,1,0-.15v-4a.76.76,0,0,1,0-.15h48A2.13,2.13,0,0,1,95,49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.05,32.91A19.85,19.85,0,1,1,77.2,13.06,19.85,19.85,0,0,1,97.05,32.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.69,32.91A13.49,13.49,0,1,1,77.2,19.42,13.49,13.49,0,0,1,90.69,32.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.2,29.79a2.14,2.14,0,0,1-2.14-2.14V25a2.14,2.14,0,0,1,4.28,0v2.67a2.14,2.14,0,0,1-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85,35.05H85a2.14,2.14,0,0,1,0-4.28h0a2.14,2.14,0,0,1,0,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.22,42.19h0a2.14,2.14,0,0,1,0-4.28h.06a2.14,2.14,0,0,1,0,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.21,35.05h0a2.14,2.14,0,0,1,0-4.28h0a2.14,2.14,0,0,1,0,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.53,81.39A12.64,12.64,0,0,0,45,75a12.64,12.64,0,0,0-23.58,6.35C21.38,99.08,45,114.32,45,114.32S68.53,99.08,68.53,81.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.53,81.39C68.53,99.08,45,114.32,45,114.32s-2.06-1.33-5-3.66c6.92-5.55,18.63-16.8,18.63-29.27a12.64,12.64,0,0,0-7.7-11.64,12.65,12.65,0,0,1,17.6,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.58,121.68a2.14,2.14,0,0,1-2.14-2.14V85.88a2.14,2.14,0,1,1,4.28,0v33.66a2.14,2.14,0,0,1-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.88,146.91a2.14,2.14,0,0,1-2.14-2.14V59.44a2.14,2.14,0,0,1,4.28,0v85.33a2.14,2.14,0,0,1-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.12,84.8h0l-3.27,0a2.14,2.14,0,0,1,0-4.28h0l3.28,0a2.14,2.14,0,0,1,0,4.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M11.63,94.26a2.14,2.14,0,0,1-1.06-4l2.85-1.62a2.15,2.15,0,0,1,2.12,3.73L12.69,94a2.16,2.16,0,0,1-1.06.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.6,77a2.15,2.15,0,0,1-1.09-.29L10.69,75a2.14,2.14,0,0,1,2.17-3.69L15.68,73a2.14,2.14,0,0,1-1.08,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.28,84.8a2.14,2.14,0,0,1,0-4.28l3.27,0h0a2.14,2.14,0,0,1,0,4.28l-3.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.77,94.26a2.09,2.09,0,0,1-1-.28l-2.85-1.61A2.14,2.14,0,1,1,77,88.64l2.85,1.62a2.14,2.14,0,0,1-1.06,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.81,77a2.14,2.14,0,0,1-1.09-4l2.82-1.66A2.14,2.14,0,1,1,79.71,75l-2.82,1.66a2.14,2.14,0,0,1-1.08.29Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaPflegehilfsmittel);
export default __webpack_public_path__ + "static/media/ka_pflegehilfsmittel.fb798e07855c9e4a3634ed5df7e87c05.svg";
export { ForwardRef as ReactComponent };